import { Icon, type IconName } from '@speaking-coach/ui'
import type { BrowserEnvironment } from './browser-environment'

type DeviceClass = BrowserEnvironment['deviceClass']

export const DEVICE_LABELS: Record<DeviceClass, string> = {
  desktop: 'Desktop', mobile: 'Mobile', tablet: 'Tablet', unknown: 'Unknown device',
}
const DEVICE_ICONS: Record<DeviceClass, IconName> = {
  desktop: 'deviceDesktop', mobile: 'deviceMobile', tablet: 'deviceTablet', unknown: 'unknown',
}

/** One device display for call/feedback lists and global environment reporting. */
export function DeviceValue({ deviceClass }: { deviceClass: DeviceClass | null | undefined }): JSX.Element {
  if (!deviceClass) return <span className="text-text-secondary italic">Not recorded</span>
  return <span className="inline-flex items-center gap-2 whitespace-nowrap">
    <Icon name={DEVICE_ICONS[deviceClass]} className="shrink-0 text-text-secondary" />
    {DEVICE_LABELS[deviceClass]}
  </span>
}
